import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { BRAND } from "../../components/auth/authTheme";

const StatusReasonModal = ({ open, handleClose, handleSubmit, newStatus }) => {
  const [reason, setReason] = useState("");

  const onSubmit = () => {
    if (!reason.trim()) return;
    handleSubmit(reason);
    setReason("");
  };

  const onCancel = () => {
    setReason("");
    handleClose();
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: BRAND.navy, fontWeight: 700 }}>
        Reason Required
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2, color: BRAND.navy }}>
          Please provide a reason for changing the status to{" "}
          <strong>{newStatus}</strong>.
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="Reason"
          type="text"
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: BRAND.orange,
              },
            },
            "& label.Mui-focused": {
              color: BRAND.orange,
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onCancel} sx={{ color: BRAND.muted, fontWeight: 600 }}>
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={!reason.trim()}
          sx={{
            bgcolor: BRAND.orange,
            color: "#fff",
            fontWeight: 600,
            "&:hover": { bgcolor: BRAND.navy },
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusReasonModal;
